import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropdown", "badge"]

  connect() {
    this.boundHandleClickOutside = this.handleClickOutside.bind(this)
  }

  disconnect() {
    document.removeEventListener("click", this.boundHandleClickOutside)
  }

  toggle(event) {
    event.stopPropagation()

    if (this.hasDropdownTarget) {
      if (this.dropdownTarget.classList.contains("hidden")) {
        this.show()
      } else {
        this.hide()
      }
    }
  }

  show() {
    this.dropdownTarget.classList.remove("hidden")
    setTimeout(() => {
      document.addEventListener("click", this.boundHandleClickOutside)
    }, 10)
  }

  hide() {
    this.dropdownTarget.classList.add("hidden")
    document.removeEventListener("click", this.boundHandleClickOutside)
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hide()
    }
  }
}
